import { ActionIcon, Button, Container, createTheme, MantineProvider, Switch, Tooltip } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_settings/configuracoes")({
  component: RouteComponent
});

const theme = createTheme({
  components: {
    Button: Button.extend({
      defaultProps: {
        radius: "sm",
        size: "sm"
      }
    }),
    Switch: Switch.extend({
      defaultProps: {
        size: "lg",
        withThumbIndicator: false,
        color: "teal"
      }
      // classNames: {
      //   body: cn("flex items-center"),
      //   label: cn("!text-sm font-medium"),
      //   description: cn("!pt-0 !text-xs")
      // }
    }),
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        variant: "light",
        radius: "xl",
        size: "md"
      }
    }),
    Tooltip: Tooltip.extend({
      defaultProps: {
        withArrow: true,
        position: "top"
      }
    })
  }
});

function RouteComponent() {
  return (
    <MantineProvider theme={theme}>
      <Container size="xl" py="md" px={0}>
        <Outlet />
      </Container>
    </MantineProvider>
  );
}
